<template>
  <div>
    <TagSelector mainHeading="" optionName="users" availableOptionsHeading="All Users"
      selectedOptionsHeading="Current Activity Admins" :initial-skills="availableAllUsers" :showDefaultMessage="false"
      v-model:interests="currentAdmins" :onSave="readOnly ? null : handleSaveAdmins" :loading="loading" :isSaving="submitting" />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import TagSelector from "@/components/common/TagSelector.vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";

defineProps({
    readOnly: { type: Boolean, default: false }
});

const store = useStore();
const route = useRoute();
const toast = useToast();
const loading = ref(false);
const submitting = ref(false);

const activityId = route.params.activityid;

const availableAllUsers = ref([]);
const currentAdmins = ref([]);

const loadAdmins = async () => {
  loading.value = true;
  try {
    const admins = await store.dispatch("fetchAdmins", activityId);

    currentAdmins.value = admins.admins.map((user) => ({
      id: user.personid,
      name: `${user.firstname} ${user.lastname}`,
      description: user.email || "",
    }));

    availableAllUsers.value = admins.available_users.map((user) => ({
      id: user.personid,
      name: `${user.firstname} ${user.lastname}`,
      description: user.email || "",
    }));
  } catch (error) {
    console.error("Failed to load admins:", error);
    toast.error("Failed to load activity admins");
  } finally {
    loading.value = false;
  }
};

// ✅ Save handler
const handleSaveAdmins = async (selected) => {
  submitting.value = true;
  try {
    const userIds = selected.map((x) => x.id);

    const result = await store.dispatch("saveAdmins", {
      activityId,
      userIdsArray: userIds,
    });

    if (result.success) {
      toast.success(result.message || "Admins updated successfully");
      await loadAdmins(); // refresh the list after saving
    } else {
      toast.error(result.message || "Failed to save admins");
    }
  } finally {
    submitting.value = false;
  }
};

// ✅ Load admins on mount
onMounted(() => {
  loadAdmins();
});
</script>
